import {ITokenData, IUser} from '@/app/auth';
import {store} from '@/app/store';
import {AuthState, selectUser} from '@/app/store/authSlice';

import {selectTokenData, TokenState} from './tokenSlice';

let currentUser: IUser | null = null;
let currentTokenData: ITokenData | null = null;

export const userManager = {
  updateUser: () => {
    const state: {auth: AuthState} = store.getState() as {auth: AuthState};
    currentUser = selectUser(state);
  },

  getUser: () => {
    if (!currentUser) {
      userManager.updateUser();
    }
    return currentUser;
  },

  updateToken: () => {
    const state: {tokenDataSlice: TokenState} = store.getState() as {
      tokenDataSlice: TokenState;
    };
    currentTokenData = selectTokenData(state);
  },

  clearToken: () => {
    currentUser = null;
    currentTokenData = null;
  },

  getToken: () => {
    if (!currentTokenData) {
      userManager.updateToken();
    }
    return currentTokenData;
  },
};
